const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "m-scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "m-scroll-trigger--offscreen";
const SCROLL_ANIMATION_CANCEL_CLASSNAME = "m-scroll-trigger--cancel";
const SCROLL_ANIMATION_INITIALIZED_CLASSNAME = "m-scroll-trigger--initialized";

function updateElementVisibility(element, isVisible) {
  if (isVisible) {
    element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
  } else {
    element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    element.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
  }
}

function handleMobileChange(element) {
  const removeTriggerClass = () => element.classList.remove(SCROLL_ANIMATION_TRIGGER_CLASSNAME);

  if (MinimogTheme.config.mqlMobile || element.dataset.type === "fixed") {
    removeTriggerClass();
  }

  document.addEventListener("matchMobile", removeTriggerClass);
  document.addEventListener("unmatchMobile", removeTriggerClass);
}

function onIntersection(entries, observerInstance) {
  entries.forEach((entry, index) => {
    const { isIntersecting, target } = entry;
    updateElementVisibility(target, isIntersecting);

    if (isIntersecting) {
      if (
        target.hasAttribute("data-cascade") &&
        !target.style.getPropertyValue("--animation-order")
      ) {
        target.style.setProperty("--animation-order", String(index + 1));
      }
      observerInstance.unobserve(target);
    }

    if (target.classList.contains("m-sidebar")) {
      handleMobileChange(target);
    }
  });
}

const observer = new IntersectionObserver(onIntersection, {
  rootMargin: "0px 0px -150px 0px",
});

function getScrollAnimationElements(rootEl = document) {
  const elements = [];

  if (
    rootEl instanceof Element &&
    rootEl.classList.contains(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  ) {
    elements.push(rootEl);
  }

  if (typeof rootEl.querySelectorAll === "function") {
    elements.push(
      ...rootEl.querySelectorAll(`.${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`)
    );
  }

  return [...new Set(elements)];
}

function prepareScrollAnimationElement(element, replay = false) {
  observer.unobserve(element);
  element.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
  element.classList.add(
    SCROLL_ANIMATION_INITIALIZED_CLASSNAME,
    SCROLL_ANIMATION_OFFSCREEN_CLASSNAME
  );

  if (replay) {
    void element.offsetWidth;
  }

  observer.observe(element);
}

function initializeScrollAnimationTrigger(rootEl = document, replay = false) {
  const elements = getScrollAnimationElements(rootEl);
  elements.forEach((element) => prepareScrollAnimationElement(element, replay));
}

// This defer-loaded script runs after parsing. Initialize immediately so
// below-the-fold elements cannot animate before observer registration.
initializeScrollAnimationTrigger();

if (Shopify.designMode) {
  const reinitialize = (event) => {
    window.requestAnimationFrame(() => {
      initializeScrollAnimationTrigger(event.target, true);
    });
  };

  document.addEventListener("shopify:section:load", reinitialize);
  document.addEventListener("shopify:section:select", reinitialize);
  document.addEventListener("shopify:section:reorder", () => {
    window.requestAnimationFrame(() => {
      initializeScrollAnimationTrigger(document, true);
    });
  });
}
